<div class="content bg-grey-hover-10 gap-16">
  <div class="is-flex is-align-center gap-8">
    <ng-content select="app-control-page-card-icon"></ng-content>
    <ng-content select="app-control-page-card-label"></ng-content>
  </div>
  <div>
    <ng-content select="app-control-page-card-expand"></ng-content>
  </div>
</div>